document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  if (!body) {
    return;
  }
  //This Breakpoints mus match those defined in src/scss/_bootstrap.scss
  const BREAKPOINTS = [
    { query: '(max-width: 1700px) and (min-width: 1450px)', name: 'xl' },
    { query: '(max-width: 1449px) and (min-width: 1180px)', name: 'lg' },
    { query: '(max-width: 1179px) and (min-width: 768px)', name: 'md' },
    { query: '(max-width: 767px) and (min-width: 576px)', name: 'sm' },
    { query: '(max-width: 575px)', name: 'xs' },
  ];

  const CLASS_NAMES = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
  const MOBILE_BREAKPOINTS = new Set(['xs', 'sm', 'md']);
  const MEGAMENU_DRAWER_BREAKPOINTS = new Set(['xs', 'sm', 'md']);
  const MEGAMENU_DRAWER_OPEN_CLASS = 'is-megamenu-drawer-open';
  const MEGAMENU_OVERLAY_OPEN_CLASS = 'is-megamenu-overlay-open';
  const SCROLL_DOWN_CLASS = 'is-scrolling-down';
  const DIRECTION_THRESHOLD = 8;

  const mediaQueries = BREAKPOINTS.map((breakpoint) => ({
    ...breakpoint,
    mql: window.matchMedia(breakpoint.query),
  }));

  let breakpoint = '';
  let isMobile = '';

  const isMegamenuDrawerMode = () => MEGAMENU_DRAWER_BREAKPOINTS.has(breakpoint);

  const getOpenMegamenuPanels = () => (
    document.querySelectorAll('.navbar-nav > .position-static > .megamenu-panel.show')
  );

  const getMegamenuToggle = (panel) => {
    const dropdown = panel.closest('.dropdown');

    if (!dropdown) {
      return null;
    }

    return dropdown.querySelector(':scope > [data-bs-toggle="dropdown"]');
  };

  const syncMegamenuState = () => {
    const hasOpenPanel = getOpenMegamenuPanels().length > 0;
    const drawerMode = isMegamenuDrawerMode();

    // Mobile/tablet: the panel behaves like an offcanvas drawer.
    body.classList.toggle(MEGAMENU_DRAWER_OPEN_CLASS, drawerMode && hasOpenPanel);
    // Desktop: dim the page content behind the open megamenu panel.
    body.classList.toggle(MEGAMENU_OVERLAY_OPEN_CLASS, !drawerMode && hasOpenPanel);
  };

  const resetMegamenuCardDropdowns = (root = document) => {
    root.querySelectorAll('.megamenu-card.is-open').forEach((card) => {
      card.classList.remove('is-open');
      card.querySelector('[data-cbi-megamenu-subtoggle]')?.setAttribute('aria-expanded', 'false');
    });
  };

  const toggleMegamenuCardDropdown = (event) => {
    const subToggle = event.target.closest('[data-cbi-megamenu-subtoggle]');

    if (!subToggle || !isMegamenuDrawerMode()) {
      return false;
    }

    const card = subToggle.closest('.megamenu-card');
    const panel = subToggle.closest('.megamenu-panel');

    if (!card || !panel) {
      return false;
    }

    event.preventDefault();
    event.stopPropagation();
    card.classList.toggle('is-open');
    subToggle.setAttribute('aria-expanded', card.classList.contains('is-open') ? 'true' : 'false');

    return true;
  };

  const keepMegamenuDrawerOpen = (event) => {
    if (!isMegamenuDrawerMode() || !event.clickEvent) {
      return;
    }

    const dropdown = event.target.closest('.dropdown');
    const panel = dropdown?.querySelector(':scope > .megamenu-panel');

    if (!panel) {
      return;
    }

    const clickTarget = event.clickEvent.target;

    if (clickTarget.closest('.megamenu-drawer-close')) {
      return;
    }

    event.preventDefault();
  };

  const hideMegamenuPanel = (panel) => {
    const toggle = getMegamenuToggle(panel);
    const Dropdown = window.bootstrap?.Dropdown || window.Dropdown;

    if (toggle && Dropdown) {
      Dropdown.getOrCreateInstance(toggle).hide();
      return;
    }

    panel.classList.remove('show');
    toggle?.classList.remove('show');
    toggle?.setAttribute('aria-expanded', 'false');
    resetMegamenuCardDropdowns(panel);
    syncMegamenuState();
  };

  const closeMegamenuDrawers = () => {
    getOpenMegamenuPanels().forEach(hideMegamenuPanel);
    body.classList.remove(MEGAMENU_DRAWER_OPEN_CLASS, MEGAMENU_OVERLAY_OPEN_CLASS);
  };

  const updateDeviceMode = (value) => {
    isMobile = MOBILE_BREAKPOINTS.has(value) ? 'Mobile' : 'Desktop';

    if (!MOBILE_BREAKPOINTS.has(value)) {
      // equalHeights();
    } else {
      // removeEqualHeights();
    }
  };

  const applyBreakpoint = () => {
    const matched = mediaQueries.find(({ mql }) => mql.matches);
    const next = matched ? matched.name : 'xxl';

    if (next === breakpoint) {
      return;
    }

    body.classList.remove(...CLASS_NAMES);
    body.classList.add(next);
    breakpoint = next;
    updateDeviceMode(next);

    if (isMegamenuDrawerMode()) {
      syncMegamenuState();
    } else {
      closeMegamenuDrawers();
    }
  };

  const registerMegamenuDrawers = () => {
    document.addEventListener('hide.bs.dropdown', keepMegamenuDrawerOpen);

    document.addEventListener('shown.bs.dropdown', () => {
      window.requestAnimationFrame(syncMegamenuState);
    });

    document.addEventListener('hidden.bs.dropdown', (event) => {
      const dropdown = event.target.closest('.dropdown');
      const panel = dropdown?.querySelector(':scope > .megamenu-panel');

      if (panel) {
        resetMegamenuCardDropdowns(panel);
      }

      window.requestAnimationFrame(syncMegamenuState);
    });

    document.addEventListener('click', toggleMegamenuCardDropdown, true);

    document.addEventListener('click', (event) => {
      const closeButton = event.target.closest('.megamenu-drawer-close');

      if (!closeButton) {
        return;
      }

      const panel = closeButton.closest('.megamenu-panel');

      if (!panel) {
        return;
      }

      event.preventDefault();
      hideMegamenuPanel(panel);
    });
  };

  const registerMastheadScroll = () => {
    const masthead = document.getElementById('masthead');
    if (!masthead) {
      return;
    }

    let lastScrollY = window.scrollY || window.pageYOffset;
    let ticking = false;
    let direction = 'up';
    let isToggling = false;

    const updateState = () => {
      const currentY = window.scrollY || window.pageYOffset;

      // If we are in the middle of a toggle transition, update lastScrollY and ignore logic
      // This prevents layout shifts from triggering a reverse toggle (flicker loop)
      if (isToggling) {
        lastScrollY = currentY;
        ticking = false;
        return;
      }

      const delta = currentY - lastScrollY;

      if (Math.abs(delta) < DIRECTION_THRESHOLD) {
        ticking = false;
        return;
      }

      const nextDirection = delta > 0 ? 'down' : 'up';

      if (nextDirection !== direction) {
        direction = nextDirection;

        // Apply changes and set toggle lock
        isToggling = true;

        if (direction === 'down' && currentY > DIRECTION_THRESHOLD) {
          masthead.classList.add(SCROLL_DOWN_CLASS);
        } else {
          masthead.classList.remove(SCROLL_DOWN_CLASS);
        }

        // Unlock after transition (approx 300ms based on CSS)
        setTimeout(() => {
          isToggling = false;
          // Refresh lastScrollY to current position after transition to resume tracking safely
          lastScrollY = window.scrollY || window.pageYOffset;
        }, 350);
      }

      if (currentY <= 0 && masthead.classList.contains(SCROLL_DOWN_CLASS)) {
        direction = 'up';
        masthead.classList.remove(SCROLL_DOWN_CLASS);
      }

      lastScrollY = currentY;
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateState);
          ticking = true;
        }
      },
      { passive: true }
    );
  };

  /**
   * Applies Bootstrap validation state to forms that opt into native validation.
   */
  const registerBootstrapValidation = () => {
    document.querySelectorAll('.needs-validation').forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        form.classList.add('was-validated');
      });
    });
  };

  /**
   * Submits opt-in forms through their WordPress admin-ajax endpoint.
   */
  const registerAjaxForms = () => {
    document.querySelectorAll('form[data-ajax-form]').forEach((form) => {
      const originalMarkup = form.innerHTML;

      /**
       * Replaces the form contents with the server response and reset control.
       */
      const renderResponse = (type, message, buttonLabel = form.dataset.resetLabel || 'Try again') => {
        form.classList.remove('was-validated');
        form.innerHTML = '';

        const alert = document.createElement('div');
        alert.className = `alert alert-${type === 'success' ? 'success' : 'danger'} mb-3`;
        alert.setAttribute('role', 'alert');
        alert.textContent = message;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'btn btn-lime btn-sm';
        button.textContent = buttonLabel;
        button.addEventListener('click', () => {
          form.innerHTML = originalMarkup;
          form.classList.remove('was-validated');
          form.querySelector('input:not([type="hidden"]), textarea')?.focus();
        });

        form.append(alert, button);
      };

      form.addEventListener('submit', async (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          form.classList.add('was-validated');
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton?.textContent || '';

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = form.dataset.sendingLabel || 'Sending...';
        }

        try {
          const response = await window.fetch(form.getAttribute('action'), {
            method: form.getAttribute('method') || 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
          });

          const rawResponse = await response.text();
          let data = null;

          try {
            data = JSON.parse(rawResponse);
          } catch (parseError) {
            data = null;
          }

          const payload = data?.data || {};
          const details = Array.isArray(payload.errors) && payload.errors.length
            ? ` ${payload.errors.join(' ')}`
            : '';
          const htmlResponse = /^\s*<!doctype html|^\s*<html/i.test(rawResponse);
          const fallbackMessage = htmlResponse
            ? `${form.dataset.errorMessage || 'The request failed.'} (${response.status || 'unknown status'})`
            : rawResponse;

          if (!response.ok || !data?.success) {
            throw new Error(
              `${payload.message || fallbackMessage || form.dataset.errorMessage || 'The request could not be completed. Please try again.'}${details}`
            );
          }

          renderResponse('success', payload.message, payload.buttonLabel);
        } catch (error) {
          renderResponse('error', error.message || form.dataset.errorMessage || 'The request could not be completed. Please try again.');
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
        }
      });
    });
  };

  mediaQueries.forEach(({ mql }) => {
    mql.addEventListener('change', applyBreakpoint);
  });

  registerMastheadScroll();
  registerMegamenuDrawers();
  registerBootstrapValidation();
  registerAjaxForms();
  applyBreakpoint();
  const initScrollableX = () => {
    const scrollables = document.querySelectorAll('.js-scrollable-x');
    const threshold = 10;

    const hasHorizontalOverflow = (scrollable) => (
      scrollable.scrollWidth - scrollable.clientWidth > threshold
    );

    const createArrow = (direction) => {
      const arrow = document.createElement('button');
      const isPrev = direction === 'prev';

      arrow.type = 'button';
      arrow.className = `scrollable-x-arrow scrollable-x-arrow--${direction}`;
      arrow.setAttribute('aria-label', isPrev ? 'Scroll left' : 'Scroll right');
      arrow.innerHTML = '<span aria-hidden="true"></span>';

      return arrow;
    };

    const setupScrollable = (scrollable) => {
      if (scrollable.dataset.scrollableXReady === 'true') {
        return;
      }

      const controlsType = scrollable.dataset.scrollableXControls === 'bullets' ? 'bullets' : 'arrows';
      const items = Array.from(scrollable.children);

      const navSelector = scrollable.dataset.scrollableXNav || '';
      const navScope = scrollable.parentElement || document;
      const navButtons = navSelector
        ? Array.from(navScope.querySelectorAll(`${navSelector} [data-target]`))
        : [];

      const controls = document.createElement('div');
      controls.className = `scrollable-x-controls scrollable-x-controls--${controlsType}`;

      let prevArrow = null;
      let nextArrow = null;
      const bullets = [];

      const getItemOffset = (item) => (
        item.getBoundingClientRect().left
        - scrollable.getBoundingClientRect().left
        + scrollable.scrollLeft
      );

      const scrollToItem = (index) => {
        const item = items[index];

        if (!item) return;

        scrollable.scrollTo({ left: getItemOffset(item), behavior: 'smooth' });
      };

      if (controlsType === 'bullets') {
        scrollable.classList.add('scrollable-x--paged');

        items.forEach((item, index) => {
          const bullet = document.createElement('button');

          bullet.type = 'button';
          bullet.className = 'scrollable-x-bullet';
          bullet.setAttribute('aria-label', `Go to item ${index + 1}`);
          bullet.addEventListener('click', () => scrollToItem(index));

          controls.appendChild(bullet);
          bullets.push(bullet);
        });
      } else {
        prevArrow = createArrow('prev');
        nextArrow = createArrow('next');
        controls.append(prevArrow, nextArrow);
      }

      scrollable.insertAdjacentElement('afterend', controls);

      navButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          const targetId = button.dataset.target;
          const index = items.findIndex((item) => item.id === targetId);

          if (index !== -1) scrollToItem(index);
        });
      });

      const getActiveIndex = () => {
        const base = scrollable.getBoundingClientRect().left;
        let activeIndex = 0;
        let minDistance = Infinity;

        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - base);

          if (distance < minDistance) {
            minDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const updateActiveState = () => {
        const activeItem = items[getActiveIndex()];

        bullets.forEach((bullet, index) => {
          bullet.classList.toggle('is-active', items[index] === activeItem);
        });

        navButtons.forEach((button) => {
          button.classList.toggle('active', !!activeItem && button.dataset.target === activeItem.id);
        });
      };

      scrollable.dataset.scrollableXReady = 'true';

      let arrowTicking = false;
      let hasOverflow = false;

      const updateArrows = () => {
        const maxScrollLeft = scrollable.scrollWidth - scrollable.clientWidth;
        hasOverflow = maxScrollLeft > threshold;

        if (prevArrow) {
          prevArrow.classList.toggle(
            'scrollable-x-arrow--hidden',
            !hasOverflow || scrollable.scrollLeft <= threshold
          );
        }

        if (nextArrow) {
          nextArrow.classList.toggle(
            'scrollable-x-arrow--hidden',
            !hasOverflow || scrollable.scrollLeft >= maxScrollLeft - threshold
          );
        }

        controls.classList.toggle('scrollable-x-controls--hidden', !hasOverflow);
        scrollable.classList.toggle('has-scrollable-x-overflow', hasOverflow);

        updateActiveState();

        arrowTicking = false;
      };

      const requestArrowUpdate = () => {
        if (!arrowTicking) {
          window.requestAnimationFrame(updateArrows);
          arrowTicking = true;
        }
      };

      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;
      let didDrag = false;
      const dragThreshold = 6;
      const clickSuppressDuration = 250;
      let suppressClickUntil = 0;

      const onMouseMove = (event) => {
        if (!isDragging) return;

        const delta = event.clientX - startX;

        event.preventDefault();

        if (!didDrag && Math.abs(delta) > dragThreshold) {
          didDrag = true;
        }

        scrollable.scrollLeft = scrollLeft - delta;
      };

      const stopDragging = () => {
        if (!isDragging) return;

        if (didDrag) {
          suppressClickUntil = Date.now() + clickSuppressDuration;
        }

        isDragging = false;
        scrollable.classList.remove('is-dragging');
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', stopDragging);
      };

      scrollable.addEventListener('mousedown', (event) => {
        if (event.button !== 0) return;
        if (!hasOverflow) return;

        isDragging = true;
        didDrag = false;
        startX = event.clientX;
        scrollLeft = scrollable.scrollLeft;
        scrollable.classList.add('is-dragging');
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', stopDragging);
      });

      scrollable.addEventListener('mouseleave', stopDragging);

      scrollable.addEventListener(
        'click',
        (event) => {
          if (!didDrag && Date.now() > suppressClickUntil) return;

          if (Date.now() > suppressClickUntil) {
            didDrag = false;
            return;
          }

          const clickable = event.target.closest('a, button, input, textarea, select, label');

          didDrag = false;

          if (!clickable) return;

          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      scrollable.addEventListener('dragstart', (event) => {
        if (!isDragging) return;

        event.preventDefault();
      });

      const getScrollAmount = () => {
        const styles = window.getComputedStyle(scrollable);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;

        return scrollable.clientWidth + gap;
      };

      if (prevArrow) {
        prevArrow.addEventListener('click', (event) => {
          event.preventDefault();
          scrollable.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (nextArrow) {
        nextArrow.addEventListener('click', (event) => {
          event.preventDefault();
          scrollable.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      scrollable.addEventListener('scroll', requestArrowUpdate, { passive: true });
      window.addEventListener('resize', requestArrowUpdate);

      requestArrowUpdate();
    };

    const initWhenOverflowExists = (scrollable) => {
      let resizeTicking = false;

      const requestInit = () => {
        if (resizeTicking || scrollable.dataset.scrollableXReady === 'true') {
          return;
        }

        resizeTicking = true;

        window.requestAnimationFrame(() => {
          resizeTicking = false;

          if (hasHorizontalOverflow(scrollable)) {
            setupScrollable(scrollable);
            window.removeEventListener('resize', requestInit);
          }
        });
      };

      requestInit();
      window.addEventListener('resize', requestInit);
    };

    scrollables.forEach((scrollable) => {
      initWhenOverflowExists(scrollable);
    });
  };

  initScrollableX();

  const initEmergencyTabs = () => {
    document.querySelectorAll('.js-emergency-tabs').forEach((root) => {
      const buttons = Array.from(root.querySelectorAll('.emergency-tabs-nav [data-target]'));
      const panels = Array.from(root.querySelectorAll('.emergency-tab-panel'));

      if (!buttons.length || !panels.length) {
        return;
      }

      const activate = (targetId) => {
        buttons.forEach((button) => {
          const isActive = button.dataset.target === targetId;

          button.classList.toggle('active', isActive);
          button.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach((panel) => {
          const isActive = panel.id === targetId;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;

          if (!isActive) {
            panel.querySelectorAll('video').forEach((video) => {
              video.pause();
            });
          }
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          activate(button.dataset.target);
        });
      });

      const initial = buttons.find((button) => button.classList.contains('active')) || buttons[0];
      activate(initial.dataset.target);
    });
  };

  initEmergencyTabs();

  document.querySelectorAll('form[data-cbi-tax-facets-url]').forEach((form) => {
    const selects = [...form.querySelectorAll('.js-searchwp-tax-filter')];
    const searchInput = form.querySelector('input[data-swplive="true"]');
    let facetsRequest = null;

    if (!selects.length) {
      return;
    }

    const refreshLiveSearch = () => {
      if (searchInput?.value.trim()) {
        searchInput.dispatchEvent(new Event('keyup', { bubbles: true }));
      }
    };

    const syncFacets = async (refreshResults = true, changedTaxonomy = '') => {
      facetsRequest?.abort();

      const request = new AbortController();
      const requestData = new FormData(form);

      facetsRequest = request;
      requestData.set('action', 'cbi_searchwp_sync_taxonomy_facets');
      requestData.set('nonce', form.dataset.cbiTaxFacetsNonce || '');
      requestData.set('cbi_swp_changed_taxonomy', changedTaxonomy);
      selects.forEach((select) => {
        select.setAttribute('aria-busy', 'true');
      });

      try {
        const response = await fetch(form.dataset.cbiTaxFacetsUrl, {
          method: 'POST',
          body: requestData,
          credentials: 'same-origin',
          signal: request.signal,
        });
        const payload = await response.json();

        if (!response.ok || !payload?.success || !payload.data?.facets) {
          throw new Error('Could not synchronize the search filters.');
        }

        Object.entries(payload.data.facets).forEach(([taxonomy, facet]) => {
          const select = selects.find((item) => item.dataset.taxonomy === taxonomy);

          if (!select) {
            return;
          }

          select.replaceChildren();
          select.add(new Option(facet.all_label, ''));
          facet.options.forEach((option) => {
            select.add(new Option(option.label, String(option.value)));
          });
          select.value = facet.selected ? String(facet.selected) : '';
        });
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        console.error(error);
      } finally {
        if (facetsRequest === request) {
          selects.forEach((select) => {
            select.removeAttribute('aria-busy');
          });

          if (refreshResults) {
            refreshLiveSearch();
          }
        }
      }
    };

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        syncFacets(true, select.dataset.taxonomy || '');
      });
    });

    if (selects.some((select) => select.value)) {
      syncFacets(false);
    }
  });
});
